module.exports = __webpack_public_path__ + "static/media/red-pay.266d18be.png";